import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useAuthCheck } from "../hooks/useAuthCheck";

const ProtectedRoute = ({ children }) => {
  const { user } = useAuth();
    const { isAuthenticated } = useAuthCheck(["user.read"]);

    if (isAuthenticated)
      return children;

  if (!user) {
    return <Navigate to="/login" />;
  }

  return children;
};

export default ProtectedRoute;
